import IntMask from './intMask'
import NumMask from './numMask'
import DateMask from './dateMask'
import TimeMask from './timeMask'
import Uppercase from './uppercase'
import CreditCard from './creditCard'
import CreditCardExp from './creditCardExp'

const mavDirectives = {
  install(Vue, options) {
    Vue.directive('int-mask', IntMask)
    Vue.directive('num-mask', NumMask)
    Vue.directive('date-mask', DateMask)
    Vue.directive('time-mask', TimeMask)
    Vue.directive('uppercase', Uppercase)
    Vue.directive('creditcard-mask', CreditCard)
    Vue.directive('creditcard-exp-mask', CreditCardExp)
  }
}
export default mavDirectives
